import Page from "../../components/page/Page";
import "./widgets.css";
import SupportWidget from "./supportWidget/SupportWidget";
import {useNavigate} from "react-router-dom";

const Widgets = () => {
    const navigate = useNavigate();

    return (
        <Page
            className="widget-container"
            title="Widgets"
            subtitle="We have tools to help you communicate better with your customers and expand your subscription lists"
            secondaryActions={[{ label: "Knowledge Base", action: () => navigate("/knowledge-base") }]}
        >
            <SupportWidget onEdit={() => navigate('/widgets/support')} />
        </Page>
    )
}

export default Widgets;
